import { useEffect, useState } from "react";

const UserDataLoader = () => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="mx-auto flex w-full max-w-xs flex-col items-center gap-8 rounded-2xl bg-white p-10">
        {/* Animated rings */}
        <div className="relative flex h-24 w-24 items-center justify-center">
          <svg
            className="absolute h-full w-full"
            style={{ animation: "uldSpin 3s linear infinite" }}
            viewBox="0 0 96 96"
          >
            <circle
              cx="48"
              cy="48"
              r="42"
              fill="none"
              stroke="#e2e8f0"
              strokeWidth="4"
            />
            <circle
              cx="48"
              cy="48"
              r="42"
              fill="none"
              stroke="#10b981"
              strokeWidth="4"
              strokeLinecap="round"
              strokeDasharray="66 198"
            />
          </svg>
          <svg
            className="absolute h-16 w-16"
            style={{ animation: "uldSpin 5s linear infinite reverse" }}
            viewBox="0 0 64 64"
          >
            <circle
              cx="32"
              cy="32"
              r="28"
              fill="none"
              stroke="#e2e8f0"
              strokeWidth="3"
            />
            <circle
              cx="32"
              cy="32"
              r="28"
              fill="none"
              stroke="#0ea5e9"
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray="44 132"
            />
          </svg>
          {/* Center dot */}
          <div
            className="h-3 w-3 rounded-full bg-emerald-500"
            style={{ animation: "uldPulse 2s ease-in-out infinite" }}
          />
        </div>

        {/* Text */}
        <div className="text-center">
          <p className="text-lg font-medium text-gray-800">
            Fetching your data{".".repeat(dotCount)}
          </p>
          <p className="text-base text-gray-400 mt-1">This won't take long</p>
        </div>

        {/* Keyframes */}
        <style>{`
        @keyframes uldSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes uldPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
      `}</style>
      </div>
    </div>
  );
};

export default UserDataLoader;
